export enum MailStatutCode {
    REQUEST = 'request',
    DEFERRED = 'deferred',
    DELIVERED = 'delivered',
    INVALID_EMAIL = 'invalid_email',
    SOFT_BOUNCE = 'soft_bounce',
    HARD_BOUNCE = 'hard_bounce',
    BLOCKED = 'blocked',
    SPAM = 'spam',
    ERROR = 'error'
}

export const MailStatutLibelle: Record<MailStatutCode, string> = {
    [MailStatutCode.REQUEST]: 'Envoi en cours',
    [MailStatutCode.DEFERRED]: 'Envoi reporté',
    [MailStatutCode.DELIVERED]: 'Email distribué',
    [MailStatutCode.INVALID_EMAIL]: 'Email invalide',
    [MailStatutCode.BLOCKED]: 'Envoi bloqué',
    [MailStatutCode.SOFT_BOUNCE]: 'Rejet temporaire',
    [MailStatutCode.HARD_BOUNCE]: 'Rejet définitif',
    [MailStatutCode.SPAM]: 'Signalé comme spam',
    [MailStatutCode.ERROR]: 'Erreur technique'
};

export class MailStatuts {
    code: string | MailStatutCode;
    libelle: string;
    date: Date;
}
